import retry from 'retry';

function isNonRetryableClientError(error: unknown): boolean {
    const status = (error as { response?: { status?: number } })?.response?.status;
    if (typeof status !== 'number') return false;
    // Retry timeouts and rate limits; fail immediately on validation / auth / not-found.
    return status >= 400 && status < 500 && status !== 408 && status !== 429;
}

export async function retryPromise<T>(func: () => Promise<T>, options: retry.OperationOptions) {
    const operation = retry.operation(options);

    return new Promise((resolve, reject) => {
        operation.attempt(() => {
            Promise.resolve(func())
                .then(r => resolve(r))
                .catch(err => {
                    if (!isNonRetryableClientError(err) && operation.retry(err)) {
                        return;
                    }

                    reject(operation.mainError() || err);
                });
        })
    });
}
